import styled from 'styled-components'

export const PaymentImage = styled('img')`
  margin-bottom: 24px;
`
